import { strEnum } from '../../utils/strenum';

export const ExportFormat = strEnum(['GeoJSON', 'KML', 'GML', 'shapefile']);
export type ExportFormat = keyof typeof ExportFormat;



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/import-export/shared/import-export.type.ts